import KeyRadioList from './key_radio_list';

export default KeyRadioList;
